import * as React from 'react';

const MemberVIPSvg = () => {
    return (
        <svg width="45" height="20" viewBox="0 0 45 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H37C41.1421 0.5 44.5 3.85786 44.5 8V12C44.5 16.1421 41.1421 19.5 37 19.5H0.5V8Z" fill="url(#vip_badge_gradient_fill)" stroke="url(#vip_badge_gradient_stroke)" />
            <text x="11" y="15.5" fontSize="14" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#1A1B2D" > VIP </text>
            <defs>
                <linearGradient id="vip_badge_gradient_fill" x1="46.9286" y1="18.5714" x2="-8.61725" y2="3.27999" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FED835" />
                    <stop offset="1" stopColor="#FFFAC3" />
                </linearGradient>
                <linearGradient id="vip_badge_gradient_stroke" x1="4.73684" y1="3.125" x2="45.2177" y2="12.1486" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE669" />
                    <stop offset="1" stopColor="#FFEE81" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default MemberVIPSvg;